export class UtilString {
  private static getCharWidth(char: string): number {
    // 全角文字（ひらがな・カタカナ・漢字 etc.）
    if (char.match(/^[^\x01-\x7E\xA1-\xDF]+$/)) return 1;
    // 全角ひらがな
    if (char.match(/^[\u3041-\u3096]+$/)) return 1;
    // 全角カタカナ
    if (char.match(/^[\u30a1-\u30f6]+$/)) return 1;
    // 半角英数字（大文字・小文字）
    if (char.match(/^[0-9a-zA-Z]+$/)) return 0.7;
    return 0.7;
  }

  /** 全角を1・半角を0.7として、文字幅の数値を判定してリターンする */
  public static totalCharWidth(str: string): number {
    if (!str) return 0;
    let totalWidth = 0;
    for (let i = 0; i < str.length; i++) {
      totalWidth += this.getCharWidth(str[i]);
    }
    return totalWidth;
  }

  public static isNullOrUndefinedOrWhiteSpace(str: any): boolean {
    if (str === null || str === undefined || str === '') {
      return true;
    } else {
      return false;
    }
  }
}
